import React, { useState, useMemo, useContext } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import { SnackbarProvider } from 'notistack';
import {
  ThemeProvider,
  createTheme,
  useTheme
} from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  IconButton,
  Button
} from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useSelector } from 'react-redux';
import { FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react';
import { getVariantConfig } from './config/themeConfig';


// Create a context for theme toggling
export const ColorModeContext = React.createContext({
  toggleColorMode: () => { },
  mode: 'dark'
});

// Comprehensive color palette — sourced from themeConfig.js
// When variant='default', returns the exact original colors.
const getDesignTokens = (mode, variant = 'default') => {
  const variantConfig = getVariantConfig(mode, variant);
  const vp = variantConfig.palette;

  return {
    palette: {
      mode,
      primary: vp.primary,
      background: vp.background,
      text: vp.text,
      buy: vp.buy,
      sell: vp.sell,
    },
    typography: {
      fontFamily: [
        'Space Grotesk',
        'system-ui',
        'sans-serif'
      ].join(','),
      h1: {
        fontFamily: 'Space Grotesk',
        fontWeight: 700,
        letterSpacing: '-1px'
      },
      body1: {
        fontFamily: 'Space Grotesk',
        fontWeight: 400
      }
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: `
          @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
        `
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: 'Space Grotesk',
            textTransform: 'none',
            borderRadius: 8
          }
        }
      }
    }
  };
};

function AppWithTheme() {
  const themeMode = useSelector(state => state.theme.mode);
  const themeVariant = useSelector(state => state.theme.variant);
  const theme = useMemo(() => createTheme(getDesignTokens(themeMode, themeVariant)), [themeMode, themeVariant]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
}


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <FpjsProvider
        loadOptions={{
          apiKey: 'aug1yja0qvVzxfBvFUlx',
        }}
      >
        <BrowserRouter>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
          >
            <AppWithTheme />
          </SnackbarProvider>
        </BrowserRouter>
      </FpjsProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);




